<template>
  <div>
    <router-view></router-view>
    <div class="apart"></div>
    <div class="footer">
      <div class="menu-item" :class="{'menu-item-on': menu === 0}" @click="changePage(0)">
        <img src="images/icon/home.png" v-show="menu !== 0" />
        <img src="images/icon/home-on.png" v-show="menu === 0" />
        <span>首页</span>
      </div>
      <div class="menu-item" :class="{'menu-item-on': menu === 1}" @click="changePage(1)">
        <img src="images/icon/calendar.png" v-show="menu !== 1" />
        <img src="images/icon/calendar-on.png" v-show="menu === 1" />
        <span>活动日历</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: 0,
      menuList: [{path: '/home'}, {path: '/calendar'}]
    }
  },
  created() {
    const path = this.$route.path
    this.menuList.forEach((item, index) => {
      if (item.path === path) {
        this.menu = index
      }
    })
    if (path === '/calendarList') {
      this.menu = 1
    }
  },
  methods: {
    changePage(item) {
      const routerPath = this.$route.path
      if (this.menu === item && routerPath == this.menuList[item].path) return
      this.menu = item
      const path = this.menuList[item].path
      this.$router.push({path})
    }
  }
}
</script>

<style lang="less" scoped>
.apart {
  height: 100px;
}

.footer {
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 0;
  display: flex;
  border: 2px solid #efefef;
  background: #fff;
  z-index: 99;
  .menu-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      margin-top: 10px;
      width: 40px;
      height: 40px;
    }
    span {
      height: 40px;
      line-height: 40px;
      font-size: 28px;
      color: #9398a5;
    }
  }
  .menu-item-on {
    span {
      color: #5690ff;
    }
  }
}
</style>
